const regions = [
  "argentina",
  "australia",
  "brazil",
  "bulgaria (bg)",
  "canada (en)",
  "chile",
  "colombia",
  "costa rica",
  "czech republic",
  "dominican republic",
  "germany",
  "global (en)",
  "greece (gr)",
  "guatemala",
  "india (en)",
  "indonesia (en)",
  "jamaica (en)",
  "japan (jp)",
  "korea (en)",
  "korea (kr)",
  "lebanon (en)",
  "malayasia (en)",
  "mexico",
  "netherlands",
  "paraguay",
  "peru",
  "reunion (fr)",
  "singapore (en)",
  "south africa (en)",
  "spain",
  "thailand",
  "ukraine (ua)",
  "united kingdom",
  "united states of america",
  "uruguay",
  "vietnam (vi)",
];

export default regions;
